import React, { useEffect, useRef, useState } from "react";
import { Button, Col, ControlLabel, FormControl, FormGroup, Row } from "react-bootstrap";
import FormControlLanguage from "../../UI/FormControlLanguage";
import ImageCropper from "../../UI/Settings/CPSettingUploadImage/ImageCropper";
import { addShopProductImage, deleteShopProductImage, getShopProductImages } from "../../../../api/cp/shop";

export default ({ id, product, onEditProperty, onSave, isSaving }) => {

    const [images, setImages] = useState([]);

    const getPhotos = async (productID) => {
        try {
            const _images = await getShopProductImages(productID);
            setImages(_images)
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        if (id) {
            getPhotos(id);
        }
    }, [id])

    const handlePhoto = async (file) => {
        try {
            if (images[0]?.id) {
                await deleteShopProductImage(images[0].id);
            }
            if (file === 'DELETE') {
                setImages([])
            } else {
                const formData = new FormData();
                formData.append('file', file);
                const response = await addShopProductImage(product.id, formData);
                setImages(response?.images || []);
            }
        } catch (e) {
            console.error(e)
        }
    }

    if (!product) return null;

    return <div>
        <FormGroup>
            <ControlLabel>Название</ControlLabel>
            <FormControlLanguage
                type="text"
                values={{
                    ru: product.titleRu || '',
                    en: product.titleEn || '',
                }}
                onChange={{
                    ru: (e) => onEditProperty('titleRu', e.target.value),
                    en: (e) => onEditProperty('titleEn', e.target.value),
                }}
                onBlur={() => onSave({titleRu: product.titleRu, titleEn: product.titleEn})}
                disabled={isSaving}
            />
        </FormGroup>
        <FormGroup>
            <ControlLabel>Описание</ControlLabel>
            <FormControlLanguage
                type="textarea"
                rows={4}
                values={{
                    ru: product.descriptionRu || '',
                    en: product.descriptionEn || '',
                }}
                onChange={{
                    ru: (e) => onEditProperty('descriptionRu', e.target.value),
                    en: (e) => onEditProperty('descriptionEn', e.target.value),
                }}
                onBlur={() => onSave({descriptionRu: product.descriptionRu, descriptionEn: product.descriptionEn})}
                disabled={isSaving}
            />
        </FormGroup>
        <Row>
            <Col xs={6}>
                <FormGroup>
                    <ControlLabel>Фото</ControlLabel>
                    <UploadPhotoControl image={images[0]?.fileUrl} onChange={(file) => handlePhoto(file)} />
                </FormGroup>
            </Col>
            <Col xs={6}>
                <FormGroup>
                    <ControlLabel>Стоимость, баллы</ControlLabel>
                    <FormControl
                        type="number"
                        value={product.price}
                        onChange={(e) => onEditProperty('price', parseInt(e.target.value))}
                        onBlur={() => onSave({price: product.price})}
                        disabled={isSaving}
                    />
                </FormGroup>
                <FormGroup>
                    <ControlLabel>Лимит</ControlLabel>
                    <FormControl
                        type="number"
                        value={product.totalLimit}
                        onChange={(e) => onEditProperty('totalLimit', e.target.value)}
                        onBlur={() => onSave({totalLimit: product.totalLimit})}
                        disabled={isSaving}
                    />
                </FormGroup>
                <FormGroup>
                    <ControlLabel>Лимит на 1 участника</ControlLabel>
                    <FormControl
                        type="number"
                        value={product.limitPerPerson}
                        onChange={(e) => onEditProperty('limitPerPerson', e.target.value)}
                        onBlur={() => onSave({limitPerPerson: product.limitPerPerson})}
                        disabled={isSaving}
                    />
                </FormGroup>
            </Col>
        </Row>
    </div>
}

const UploadPhotoControl = ({ image, onChange }) => {
    const FILE_MAX_SIZE = 20971520;
    const ALLOWED_FILE_TYPES = ['image/png', 'image/jpeg', 'image/bmp', 'image/heif', 'image/heic'];

    const [photoUrl, setPhotoUrl] = useState('');
    const [isModalVisible, setModalVisible] = useState(false);
    const [error, setError] = useState('');
    const photoInputRef = useRef();

    const handleUploadPhoto = () => {
        const file = photoInputRef.current?.files[0];

        if (!file) {
            return;
        }

        if (file.size > FILE_MAX_SIZE) {
            setError('Вес файла не должен превышать 20мб');
            return;
        }

        if (!ALLOWED_FILE_TYPES.includes(file.type)) {
            setError('Необходимый формат файла – png, jpg или bmp');
            return;
        }

        setError('');
        setPhotoUrl(URL.createObjectURL(file));
        setModalVisible(true);
    };

    const handleSavePhoto = async (url) => {
        const base64Response = await fetch(url);
        const blob = await base64Response.blob();
        const file = new File(
            [blob],
            `fileName.jpeg`,
            {
                type: 'image/jpeg',
                lastModified: new Date(),
            }
        );
        onChange(file);
        setModalVisible(false);
    };

    const handleDeletePhoto = () => {
        onChange('DELETE');
    };

    return <div>
        <FormGroup className="participant-photo">
            <FormGroup>
                <div style={{ cursor: 'pointer' }} onClick={() => photoInputRef.current.click()}>
                    {image ?
                        <img
                            src={image}
                            alt={''}
                            className="participant-photo__image"
                        /> :
                        <div style={{ width: 240, height: 240, borderRadius: 6, background: '#dddbdb', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <span>Нет</span>
                        </div>
                    }
                </div>
                <FormControl
                    type="file"
                    inputRef={ref => photoInputRef.current = ref}
                    onChange={handleUploadPhoto}
                    style={{ display: 'none' }}
                />
            </FormGroup>
            <p className="participant-photo__buttons">
                <Button
                    disabled={!image}
                    onClick={() => photoInputRef.current.click()}
                >
                    Изменить
                </Button>
                <Button
                    disabled={!image}
                    onClick={handleDeletePhoto}
                >
                    Удалить
                </Button>
            </p>
            {error && (
                <p className="participant-photo__error">
                    * {error}
                </p>
            )}
        </FormGroup>

        <ImageCropper
        isLarge
            isModalVisible={isModalVisible}
            imageUrl={photoUrl}
            fixtedCropper
            cropperWidth={800}
            cropperHeight={800}
            onSave={handleSavePhoto}
            onClose={() => setModalVisible(false)}
        />
    </div>
}